import React from "react";
import { ContactUsText2 } from "./__ContactUs";
import NavbarSave from "../components/navbar-save";
import Footer from "../components/footer";

const title = "Privacy Policy";

const PrivacyPolicy = () => {
  return (
    <>
      <NavbarSave />
      <div className="bg-white w-100 h-100 overflow-y-auto" style={{ paddingTop: 156 }}>
        <div className="container">
          <div className="fs-1 fw-bold">{title}</div>
          <p className="mb-5">Last updated: {new Date().getFullYear()}</p>
          <div className="text-left">
            <PrivacyPolicyText />
          </div>
          <div className="py-5" />
          <div className="py-5" />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PrivacyPolicy;
export { PrivacyPolicyText };

function PrivacyPolicyText() {
  return (
    <>
      <div className="fs-3 fw-semibold mt-5">1. Introduction</div>
      <p className="fs-5">
        This Privacy Policy explains how <strong>CYBERSECOPS PRIVATE LIMITED</strong> (“we,” “our,” or “us”) 
        collects, uses, protects, and manages your personal and organizational information when you use 
        <strong> SAVE (Secure AI-Based Vulnerability Assessment Tool for Enterprises)</strong>. 
        SAVE is a proprietary cybersecurity platform designed and developed entirely in-house by CYBERSECOPS PRIVATE LIMITED. 
        We do not employ any third-party developers or external processors in handling customer data. 
        By using SAVE, you acknowledge and consent to the practices outlined in this Privacy Policy.
      </p>

      <div className="fs-3 fw-semibold mt-5">2. Information We Collect</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED collects only the data necessary to provide, secure, and improve SAVE’s services. 
        The types of data we collect include:
      </p>
      <div className="fs-5">
        <li><strong>Account Information:</strong> Full name, business name, job title, email address, and contact number provided during registration.</li>
        <li><strong>Technical Data:</strong> IP address, browser type, device identifiers, operating system details, and other diagnostic data collected automatically during usage.</li>
        <li><strong>Usage Data:</strong> Logs of system scans, reports generated, timestamps, and interactions within the SAVE dashboard for improving service performance.</li>
        <li><strong>Billing and Subscription Data:</strong> Payment history, subscription status, and plan information processed through secure gateways.</li>
      </div>

      <div className="fs-3 fw-semibold mt-5">3. How We Use Your Information</div>
      <p className="fs-5">
        The data we collect is used strictly for operational, security, and service-related purposes. Specifically:
      </p>
      <ul>
        <li className="fs-5">To provide and maintain SAVE and its associated services.</li>
        <li className="fs-5">To personalize user experience and optimize system performance.</li>
        <li className="fs-5">To communicate service updates, alerts, and support-related notifications.</li>
        <li className="fs-5">To detect, prevent, and investigate cybersecurity incidents or unauthorized access attempts.</li>
        <li className="fs-5">To comply with applicable laws, regulations, and internal auditing policies.</li>
      </ul>

      <div className="fs-3 fw-semibold mt-5">4. Legal Basis for Processing</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED processes personal data on the following legal grounds:
      </p>
      <ul>
        <li className="fs-5"><strong>Consent:</strong> When you explicitly provide consent during registration or trial activation.</li>
        <li className="fs-5"><strong>Contractual Necessity:</strong> To perform obligations arising from service agreements or subscriptions.</li>
        <li className="fs-5"><strong>Legitimate Interest:</strong> For continuous product improvement, threat intelligence, and quality assurance.</li>
        <li className="fs-5"><strong>Legal Compliance:</strong> To meet legal and regulatory requirements or respond to government inquiries.</li>
      </ul>

      <div className="fs-3 fw-semibold mt-5">5. Data Storage and Security</div>
      <p className="fs-5">
        All user and system data processed by SAVE are stored on secure, access-controlled infrastructure managed exclusively 
        by CYBERSECOPS PRIVATE LIMITED. We employ robust encryption, intrusion prevention systems, firewalls, 
        and regular vulnerability assessments to protect user data from unauthorized access or disclosure. 
        Access to user information is restricted to authorized personnel under strict confidentiality agreements.
      </p>

      <div className="fs-3 fw-semibold mt-5">6. Data Sharing and Disclosure</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED does <strong>not</strong> sell, rent, lease, or trade user information to any third parties. 
        We may disclose your data only under the following circumstances:
      </p>
      <ul>
        <li className="fs-5">When required by law, regulation, or legal process.</li>
        <li className="fs-5">To enforce our Terms of Service or protect our legal rights.</li>
        <li className="fs-5">To prevent, investigate, or respond to suspected fraud, threats, or security breaches.</li>
      </ul>
      <p className="fs-5">
        All data handling and processing are performed internally by CYBERSECOPS PRIVATE LIMITED without external vendors.
      </p>

      <div className="fs-3 fw-semibold mt-5">7. Cookies and Tracking Technologies</div>
      <p className="fs-5">
        SAVE uses cookies and similar technologies to improve user experience, analyze system performance, and remember 
        user preferences. You can manage or disable cookies through your browser settings. Please note that disabling 
        cookies may impact certain functionalities of the platform.
      </p>

      <div className="fs-3 fw-semibold mt-5">8. Data Retention</div>
      <p className="fs-5">
        We retain personal and technical data only for as long as necessary to fulfill the purposes outlined in this 
        Privacy Policy, comply with our legal obligations, and maintain operational security. Once data is no longer 
        required, it is securely deleted or anonymized according to industry best practices.
      </p>

      <div className="fs-3 fw-semibold mt-5">9. Your Data Protection Rights</div>
      <p className="fs-5">
        Depending on your jurisdiction, you may have certain rights over your personal data, including:
      </p>
      <ul>
        <li className="fs-5">The right to access and receive a copy of your personal data we hold.</li>
        <li className="fs-5">The right to correct or update inaccurate information.</li>
        <li className="fs-5">The right to request deletion of your data, where legally permissible.</li>
        <li className="fs-5">The right to withdraw consent for data processing at any time.</li>
      </ul>
      <p className="fs-5">
        To exercise any of these rights, please contact us through the contact details provided below.
      </p>

      <div className="fs-3 fw-semibold mt-5">10. Data Transfers</div>
      <p className="fs-5">
        All data collected through SAVE is processed and stored within India. CYBERSECOPS PRIVATE LIMITED does not 
        transfer user data outside India unless explicitly required by law or authorized by the user in writing.
      </p>

      <div className="fs-3 fw-semibold mt-5">11. Third-Party Links</div>
      <p className="fs-5">
        SAVE may contain links to external websites for reference or educational purposes. 
        CYBERSECOPS PRIVATE LIMITED is not responsible for the content, privacy policies, or practices 
        of any external websites or services. We encourage users to review the privacy policies 
        of any third-party sites they visit.
      </p>

      <div className="fs-3 fw-semibold mt-5">12. Updates to This Privacy Policy</div>
      <p className="fs-5">
        CYBERSECOPS PRIVATE LIMITED may periodically update this Privacy Policy to reflect changes in 
        regulations, operational practices, or technological advancements. 
        Any updates will be posted on this page with a revised “Last Updated” date. 
        Continued use of SAVE after such updates constitutes acceptance of the revised terms.
      </p>

      <div className="fs-3 fw-semibold mt-5">13. Contact Us</div>
      <p className="fs-5">
        For any questions, concerns, or requests regarding this Privacy Policy, please contact our data protection team:
      </p>
      <ContactUsText2 />
    </>
  );
}
